import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ParametersModule } from '@games/core/parameters/parameters.module';
import { FitTextModule } from '@shared/components/games';
import { GlobalParametersComponent } from '../global-parameters/global-parameters.component';
import { GameDynamicBlocksModule } from '../shared/game-dynamic-blocks/game-dynamic-blocks.module';
import { GamesMaterialPackModule } from './games-material-pack.module';

@NgModule({
  imports: [
    CommonModule,
    GlobalParametersComponent,
    GameDynamicBlocksModule,
    GamesMaterialPackModule,
    ParametersModule,
    FitTextModule,
  ],
  exports: [
    GlobalParametersComponent,
    GameDynamicBlocksModule,
    GamesMaterialPackModule,
    ParametersModule,
    FitTextModule,
  ],
})
export class GamesSharedModule {}
